module.exports = {"calories":[208],"misc":[601,636],"macros":[203,204,205],"carbs":[291,209,269],"fats":[606,605,645,646],"omega3":[851,621,629,631],"amino":[454,501,502,503,504,505,506,507,508,509,510,511,512,513,514,515,516,517,518,521],"minerals":[301,303,304,305,306,307,309,312,313,315,317],"vitamins":[320,323,328,401,404,405,406,410,415,418,421,430,435],"carotenoids":[321,322,334,337,338],"flavonoids":[713,731,734,749,785,758]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/preprocessed_data/graphNutrients.json
// module id = 445
// module chunks = 3